import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Overview from "./components/Overview";
import AddressGuide from "./components/AddressGuide";
import Troubleshoot from "./components/Troubleshoot";
import OfficialPortal from "./components/OfficialPortal";
import AppDownload from "./components/AppDownload";
import BackupAccess from "./components/BackupAccess";
import Faq from "./components/Faq";
import SafetyTips from "./components/SafetyTips";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Overview />
        <AddressGuide />
        <Troubleshoot />
        <OfficialPortal />
        <AppDownload />
        <BackupAccess />
        <Faq />
        <SafetyTips />
      </main>
      <Footer />
    </div>
  );
}